import { createContext, useContext, useState } from "react";

// SignUpContext.js (sketch)
const initialSignUpDetails = {
    email: "",
    isEmailVerified: false,
    mobile: "",
    countryCode: "+91",
    isMobileVerified: false,
    first_name: "",
    last_name: "",
    password: "",
    confirm_password: "",
    redirectLogin: false,
};

const SignUpContext = createContext();

const SignUpProvider = ({ children }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [signUpDetails, setSignUpDetails] = useState(initialSignUpDetails);
    const [emailMode, setEmailMode] = useState("ENTER");
    const [phoneMode, setPhoneMode] = useState("ENTER");

    return (
        <SignUpContext.Provider
            value={{
                currentStep,
                setCurrentStep,
                signUpDetails,
                setSignUpDetails,
                emailMode,
                setEmailMode,
                phoneMode,
                setPhoneMode,
            }}
        >
            {children}
        </SignUpContext.Provider>
    );
};

export default SignUpProvider;

export const useSignUpContext = () => useContext(SignUpContext);
